import { httpsCallable } from 'firebase/functions'
import { functions } from '../firebase/config'

export async function setSecurityProtocolPassword(password) {
  const fn = httpsCallable(functions, 'setSecurityProtocolPasswordV2')
  await fn({ password })
}

export async function verifySecurityProtocolPassword(password) {
  const fn = httpsCallable(functions, 'verifySecurityProtocolPasswordV2')
  const { data } = await fn({ password })
  return !!data?.valid
}
